export default __webpack_public_path__ + "static/media/chat.102b3dc4.svg";